import {combineReducers} from 'redux';

import session from './session';
import signIn from './signIn';
import signUp from './signUp';
import passwordRecovery from './passwordRecovery';

import application from './application';
import participants from './participants';

export default combineReducers({
    session,
    signIn,
    signUp,
    passwordRecovery,
    application,
    participants
});



// WEBPACK FOOTER //
// ./src/reducers/index.js